<template>
  <el-card
    class="box-card"
    :body-style="{ padding: '5px' }"
    v-loading="loading"
  >
    <div slot="header" class="clearfix">
      <div class="box flex">
        <el-avatar class="box" size="medium" :src="data.Image"></el-avatar>
        <div class="box flex column gaps ml-5">
          <el-tooltip
            class="box"
            effect="dark"
            :content="data.Name"
            placement="top-start"
          >
            <span class="box text-truncate">{{ data.Name }}</span>
          </el-tooltip>
          <span class="box secondary-text">{{ data.ClientType }}</span>
        </div>
      </div>

      <el-dropdown
        trigger="click"
        @command="$emit('card-click-action', $event)"
        class="box"
      >
        <span class="el-dropdown-link">
          <i class="mdi mdi-dots-vertical"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(action, index) in actions"
            :key="index"
            :command="{
              command: action.command,
              data: data
            }"
            :icon="action.icon"
            >{{ action.label }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="text item mt-1">
      <div class="tags">
        <el-tooltip effect="dark" content="Dias de pagos" placement="top-start">
          <el-tag type="success" size="mini">{{ data.PaymentDay }}</el-tag>
        </el-tooltip>
        <el-tooltip effect="dark" content="Clasificacion" placement="top-start">
          <el-tag type="success" size="mini">{{ data.Clasification }}</el-tag>
        </el-tooltip>
        <el-tooltip
          placement="top-start"
          :content="
            data.ContractStatus >= 1
              ? 'Contrato del cliente abierto'
              : 'Contrato del cliente cerrado'
          "
        >
          <el-tag
            :type="data.ContractStatus >= 1 ? 'success' : 'danger'"
            size="mini"
            >CN</el-tag
          >
        </el-tooltip>
        <template
          v-if="
            currentCompany === COMPANYS.MTR || currentCompany === COMPANYS.TB
          "
        >
          <el-tooltip
            :content="
              data.StatusNavixy
                ? 'Servicio en Plataforma activo'
                : 'Servicio en Plataforma desactivado'
            "
            placement="top-start"
            effect="dark"
          >
            <el-tag :type="data.StatusNavixy ? 'success' : 'danger'" size="mini"
              >SP</el-tag
            >
          </el-tooltip>
        </template>
        <template v-if="data.OverdueBillsQty > 0">
          <el-tooltip
            content="Facturas vencidas"
            placement="top-start"
            effect="dark"
          >
            <el-tag type="danger" size="mini"
              >FV: {{ data.OverdueBillsQty }}</el-tag
            >
          </el-tooltip>
        </template>
        <template>
          <el-tooltip
            content="Negociaciones"
            placement="top-start"
            effect="dark"
          >
            <el-tag
              :type="data.DealsCount > 0 ? 'success' : 'danger'"
              size="mini"
            >
              {{ data.DealsCount }}
            </el-tag>
          </el-tooltip>
        </template>
      </div>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-plus"></i>
      <el-tooltip
        effect="dark"
        content="Codigo de cliente"
        placement="top-start"
      >
        <span class="ml-5 text-truncate">{{ data.ClientCode }}</span>
      </el-tooltip>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-plus"></i>
      <el-tooltip effect="dark" content="RNC/Cedula" placement="top-start">
        <span class="ml-5 text-truncate">{{ data.VatRegistrationNumber }}</span>
      </el-tooltip>
    </div>

    <div class="text item text-truncate">
      <i class="mdi mdi-cellphone-android"></i>
      <el-tooltip
        effect="dark"
        :content="data.PhoneNumber"
        placement="top-start"
      >
        <span class="ml-5">{{ data.PhoneNumber }}</span>
      </el-tooltip>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-at"></i>
      <el-tooltip effect="dark" :content="data.Email" placement="top-start">
        <span class="ml-5 text-truncate">{{ data.Email }}</span>
      </el-tooltip>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-map-marker"></i>
      <el-tooltip effect="dark" :content="data.Address" placement="top-start">
        <span class="ml-5 text-truncate">{{ data.Address }}</span>
      </el-tooltip>
    </div>
    <!-- <div class="text item text-truncate">
      <i class="mdi mdi-account-multiple"></i>
      <span> No. Empleados : </span>
      <el-tooltip effect="dark" content="No. Empleados" placement="top-start">
        <span class="ml-5 text-truncate"
          ><b>{{ data.EmployeesQuantity }}</b></span
        >
      </el-tooltip>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-laptop-chromebook"></i>
      <span> No. PC : </span>
      <el-tooltip effect="dark" content="No. PC" placement="top-start">
        <span class="ml-5 text-truncate"
          ><b>{{ data.PcQuantity }}</b></span
        >
      </el-tooltip>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-car-sports"></i>
      <span> No. Vehículos : </span>
      <el-tooltip effect="dark" content="No. Vehículos" placement="top-start">
        <span class="ml-5 text-truncate"
          ><b>{{ data.VehiclesQuantity }}</b></span
        >
      </el-tooltip>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-account-multiple"></i>
      <span> No. Clientes : </span>
      <el-tooltip effect="dark" content="No. Clientes" placement="top-start">
        <span class="ml-5 text-truncate"
          ><b>{{ data.ClientQuantity }}</b></span
        >
      </el-tooltip>
    </div>
    <div class="text item text-truncate">
      <i class="mdi mdi-web"></i>
      <span> Página Web : </span>
      <el-tooltip effect="dark" content="Página Web" placement="top-start">
        <span class="ml-5 text-truncate">{{ data.WebPage }}</span>
      </el-tooltip>
    </div> -->
    <div class="bottom clearfix" v-if="false">
      <span class="ml-5"
        ><svg
          height="24"
          viewBox="0 0 72 72"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fill-rule="evenodd">
            <rect fill="#4460A0" height="72" rx="8" width="72" />
            <path
              d="M60.4641463,13.4173171 L60.4641463,22.7278049 L54.9382927,22.7421951 C50.6068293,22.7421951 49.7721951,24.8 49.7721951,27.807561 L49.7721951,34.4702439 L60.09,34.4702439 L58.7517073,44.8887805 L49.7721951,44.8887805 L49.7721951,72 L39.0097317,72 L39.0097317,44.8887805 L30,44.8887805 L30,34.4702439 L39.0097317,34.4702439 L39.0097317,26.7858537 C39.0097317,17.8639024 44.4478049,13 52.42,13 C56.2204634,13 59.5,13.2878049 60.4641463,13.4173171 Z"
              fill="#FFF"
            />
          </g></svg
      ></span>

      <span class="ml-5">
        <svg
          height="24"
          viewBox="0 0 72 72"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fill-rule="evenodd">
            <path
              d="M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z"
              fill="#007EBB"
            />
            <path
              d="M62,62 L51.315625,62 L51.315625,43.8021149 C51.315625,38.8127542 49.4197917,36.0245323 45.4707031,36.0245323 C41.1746094,36.0245323 38.9300781,38.9261103 38.9300781,43.8021149 L38.9300781,62 L28.6333333,62 L28.6333333,27.3333333 L38.9300781,27.3333333 L38.9300781,32.0029283 C38.9300781,32.0029283 42.0260417,26.2742151 49.3825521,26.2742151 C56.7356771,26.2742151 62,30.7644705 62,40.051212 L62,62 Z M16.349349,22.7940133 C12.8420573,22.7940133 10,19.9296567 10,16.3970067 C10,12.8643566 12.8420573,10 16.349349,10 C19.8566406,10 22.6970052,12.8643566 22.6970052,16.3970067 C22.6970052,19.9296567 19.8566406,22.7940133 16.349349,22.7940133 Z M11.0325521,62 L21.769401,62 L21.769401,27.3333333 L11.0325521,27.3333333 L11.0325521,62 Z"
              fill="#FFF"
            />
          </g>
        </svg>
      </span>
    </div>
  </el-card>
</template>

<script>
import { COMPANYS } from "@/const";

export default {
  name: "CustomerCard",
  props: {
    actions: {
      type: Array,
      default: () => [],
      required: true
    },
    data: {
      type: Object,
      default: () => {
        return {
          Image: "/static/images/avatar-2.jpg",
          Name: "",
          ClientType: "",
          PhoneNumber: "",
          Email: "",
          Address: "",
          social: { facebook: "", linkedin: "" }
        };
      },
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      COMPANYS
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";

.item {
  margin-bottom: 5px;
  opacity: 0.85;
  transition: all 0.25s;
  box-sizing: border-box;
  width: 100%;

  .tags span:not(:first-child) {
    margin-left: 5px;
  }

  img {
    width: 100%;
    max-width: 100%;
  }

  &:hover {
    opacity: 1;
    box-shadow: 0px 0px 0px 4px $text-color-accent;
  }
}

.box-card {
  margin-bottom: 10px;
  .el-card__header {
    padding: 0px;
  }
}

.el-card__header {
  padding: 0px !important;

  .clearfix {
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .box.flex {
      display: flex;
      align-content: flex-start;

      .el-avatar--medium {
        width: 40px;
        height: 40px;
        align-self: center;
      }
    }

    .box.flex.gaps.column {
      max-width: 250px;
    }

    .box.flex.gaps.column:not(.reverse) > :not(:last-child) {
      margin-bottom: 1px;
    }

    .box.el-dropdown {
      i {
        font-size: 20px;
      }
    }
  }
}

@media (min-width: 480px) {
  .el-card__header {
    .clearfix {
      .box.flex.gaps.column {
        max-width: 100px;
      }
    }
  }
}

@media (min-width: 1000px) {
  .el-card__header {
    .clearfix {
      .box.flex.gaps.column {
        max-width: 150px;
      }
    }
  }
}

@media (min-width: 1200px) {
  .el-card__header {
    .clearfix {
      .box.flex.gaps.column {
        max-width: 200px;
      }
    }
  }
}

@media (min-width: 1200px) and (max-width: 1300px) {
  .el-card__header {
    .clearfix {
      .box.flex.gaps.column {
        max-width: 150px;
      }
    }
  }
}
</style>
